// Utils
import { isCurrentBrowserLogoutAction } from '../../auth/authUtils';

// Types
import { Action } from 'redux';
import { BaseVisibilityState } from './baseVisibleConnectionState';
import { VisibleConnectionStatus } from './visibleConnectionStatusTypes';
import { SOCKET_DISCONNECT, SOCKET_FORCE_DISCONNECT, SOCKET_INTERRUPTION } from '../../utils/socket/socketConstants';
import { ELECTRON_APP_SLEEP } from '../../../common/electron/electronConstants';

/**
 * The socket is currently connected - no visual indicators are shown.
 */
export class ConnectedState extends BaseVisibilityState {
    static stateKey = VisibleConnectionStatus.connected;

    nextState(action: Action) {
        if (isCurrentBrowserLogoutAction(action)) return VisibleConnectionStatus.idle;

        switch (action.type) {
            case SOCKET_DISCONNECT:
            case SOCKET_INTERRUPTION:
                return VisibleConnectionStatus.interrupted;
            case ELECTRON_APP_SLEEP:
            case SOCKET_FORCE_DISCONNECT:
                return VisibleConnectionStatus.disconnected;
            default:
                return undefined;
        }
    }
}
